import type { IntlShape } from "context/Intl/Context";
import { ACTIVE_SERVICE_CATEGORIES, ACTIVE_SERVICE_CATEGORY_KEYS } from "constants/categories";

export function getActiveServiceCategoryOptions(intl: Pick<IntlShape, "formatMessage">) {
    return ACTIVE_SERVICE_CATEGORY_KEYS.map((key) => ({
        label: intl.formatMessage(`service.label.category.${key}`),
        value: ACTIVE_SERVICE_CATEGORIES[key].category.toString(),
    }));
}
